module.exports = __webpack_public_path__ + "img/left-ad-4.89c3d912.png";